<template>
  <div class="modal fade" ref="modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="button button-transparent back-button" @click="close">
            <i class="sk-icon-long-arrow-left-regular"></i>
          </button>
        </div>
        <div class="modal-body">
          <h1 class="modal-title">Pre Order Now!</h1>
          <h2 class="modal-subtitle">The best way to order ahead.</h2>
          <img class="preorder-image" src="/images/2k-pickup.png" alt="PreOrder">
          <div class="modal-instructions">
            <div class="modal-instruction-title">It's Simple, here's how:</div>
            <div class="modal-instruction">1. Start a Pre Order</div>
            <div>Set your address for the Delivery</div>
            <div class="modal-instruction">2. Set up Delivery</div>
            <div>Choose the date and time for your delivery.</div>
            <div class="modal-instruction">3. Prepare your order</div>
            <div>Add your preferred items and Checkout to get on your way to recieving your order!</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.modal-instructions {
  max-width: 360px;
}

.back-button {
  position: absolute;
  left: 0;
  top: 0;
  width: 50px;
}

.back-button i {
  font-size: 18px;
  color: var(--sk-grey3);
}

.modal-body {
  padding-top: 0;
}

.modal-subtitle {
  color: var(--sk-grey3);
  font-size: 12px;
}

.preorder-image {
  margin: 34px auto 0 auto;
  height: 153px;
  display: block;
}
</style>

<script>

export default {
  name: "PreorderLearnModal",
  methods: {
    open() {
      $(this.$refs.modal).modal("show")
    },
    close() {
      $(this.$refs.modal).modal("hide")
    }
  }
}
</script>
